import { render } from "./CustomColorPicker.vue?vue&type=template&id=192d3243&ts=true"
import script from "./CustomColorPicker.vue?vue&type=script&lang=ts"
export * from "./CustomColorPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__